import React from 'react';

export const UserLabel = ({dato}) => {
    return (
        <div className = "UserLabel">
            <h4>{dato}</h4>
        </div>
    )
}
